import { Assets, Sprite } from 'pixi.js';

export async function loadBase64Image(url: string): Promise<string> {
  const response: Response = await fetch(url);
  const blob: Blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = (): void => {
      resolve(reader.result as string);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export async function getBase64Asset(assetName: string): Promise<string> {
  if (!Assets.cache.has(assetName)) {
    await Assets.load(assetName);
  }

  const sprite = new Sprite().props({
    texture: assetName,
  });

  const base64 = await sprite.pixi.renderer.extract.base64(sprite);
  sprite.destroy();

  return base64;
}
